var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 29,
    viewBox: "0 0 45 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0283 20.333L18.9795 8.69531H22.1004L20.1478 20.333H17.0283Z",
    fill: "#0E4595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.423 8.9463C30.8048 8.71053 29.8359 8.45752 28.6259 8.45752C25.5421 8.45752 23.37 10.0359 23.3514 12.2981C23.3341 13.9703 24.9022 14.9032 26.086 15.4598C27.3008 16.0304 27.7092 16.3941 27.7033 16.9034C27.6956 17.6835 26.7332 18.0398 25.8361 18.0398C24.5871 18.0398 23.9235 17.8634 22.8985 17.4291L22.4963 17.2441L22.0583 19.8492C22.7873 20.1742 24.1352 20.4556 25.5348 20.4702C28.8155 20.4702 30.9452 18.9098 30.9694 16.4941C30.981 15.1701 30.1496 14.1627 28.349 13.3321C27.2582 12.7938 26.5901 12.4345 26.5972 11.8894C26.5972 11.4057 27.1627 10.8884 28.3846 10.8884C29.405 10.8723 30.1444 11.0985 30.7204 11.3343L31 11.4686L31.423 8.9463Z",
    fill: "#0E4595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.454 8.69531H37.0425C36.2954 8.69531 35.7363 8.90255 35.4083 9.66039L30.7734 20.3255H34.0506C34.0506 20.3255 34.5863 18.8915 34.7075 18.5766C35.0656 18.5766 38.2493 18.5816 38.7044 18.5816C38.7978 18.9891 39.0841 20.3255 39.0841 20.3255H41.98L39.454 8.69531ZM35.6278 16.21C35.886 15.5395 36.8713 12.9568 36.8713 12.9568C36.8529 12.9878 37.1275 12.283 37.2851 11.8461L37.496 12.8494C37.496 12.8494 38.0936 15.6274 38.2185 16.2098H35.6278V16.21Z",
    fill: "#0E4595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44026 8.69531L3.40039 8.9374C4.63409 9.24094 5.73597 9.68027 6.70067 10.2268L9.46987 20.3144L12.7719 20.3107L17.6852 8.69531H14.3791L11.3237 16.6314L10.9982 15.0185C10.983 14.9687 10.9664 14.9188 10.9495 14.8687L9.88729 9.67783C9.69843 8.94091 9.15053 8.72099 8.4727 8.69531H3.44026Z",
    fill: "#0E4595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.276379b8a3ce4463a40680d3c8a88ea2.svg";
export { ForwardRef as ReactComponent };